import request from '@/utils/request'
const route_parallelcylinder = '/moment/parallelcylinder' //平行
const route_verticalcylinder = '/moment/verticalcylinder' //垂直
const route_square = '/moment/square' //方形
const route_round = '/moment/round' //饼状
const route_ballscrew = '/moment/ballscrew' //丝杆
const route_ball = '/moment/ball' //球形
const route_anyobject = '/moment/anyobject' //任意

export function parallelcylinder(data) {
  return request.post(route_parallelcylinder, data ,{
    headers:{
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

export function verticalcylinder(data) {
  return request.post(route_verticalcylinder, data ,{
    headers:{
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

export function square(data) {
  return request.post(route_square, data ,{
    headers:{
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

export function round(data) {
  return request.post(route_round, data ,{
    headers:{
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

export function ballscrew(data) {
  return request.post(route_ballscrew, data ,{
    headers:{
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

export function ball(data) {
  return request.post(route_ball, data ,{
    headers:{
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

export function anyobject(data) {
  return request.post(route_anyobject, data ,{
    headers:{
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}



// WEBPACK FOOTER //
// ./src/store/electric_compute.js